import * as Yup from 'yup';
export const MonHocSchema = Yup.object().shape({
    Ky_hieu: Yup.string().trim().required('Mã môn học là bắt buộc'),
    Ten_mon: Yup.string().trim().required('Tên môn học là bắt buộc'),
    So_tin_chi: Yup.number().typeError('Nhập số tín chỉ hợp lệ').required('Số tín chỉ là bắt buộc').min(1, 'Ít nhất 1 tín chỉ'),
    Ly_thuyet: Yup.number().typeError('Nhập số tiết lý thuyết hợp lệ').required('Nhập số tiết lý thuyết').min(0, 'Số tiết không được âm'),
    Thuc_hanh: Yup.number().typeError('Nhập số tiết thực hành hợp lệ').required('Nhập số tiết thực hành').min(0, 'Số tiết không được âm')
});
